// src/translations/en.ts
import { registerTranslation } from "@shoelace-style/localize";
var translation = {
  $code: "en",
  $name: "English",
  $dir: "ltr",
  carousel: "Carousel",
  clearEntry: "Clear entry",
  close: "Close",
  copied: "Copied",
  copy: "Copy",
  currentValue: "Current value",
  error: "Error",
  goToSlide: (slide, count) => `Go to slide ${slide} of ${count}`,
  hidePassword: "Hide password",
  loading: "Loading",
  nextSlide: "Next slide",
  numOptionsSelected: num => {
    if (num === 0) return "No options selected";
    if (num === 1) return "1 option selected";
    return `${num} options selected`;
  },
  previousSlide: "Previous slide",
  progress: "Progress",
  remove: "Remove",
  resize: "Resize",
  scrollToEnd: "Scroll to end",
  scrollToStart: "Scroll to start",
  selectAColorFromTheScreen: "Select a color from the screen",
  showPassword: "Show password",
  slideNum: slide => `Slide ${slide}`,
  toggleColorFormat: "Toggle color format",
  // Automatically generated custom translations.
  // @see scripts/vendorism/translations.vendorism.js
  closeMenu: "Close menu",
  danger: "Danger",
  fileButtonText: "Choose file",
  fileButtonTextMultiple: "Choose files",
  folderButtonText: "Choose folder",
  fileDragDrop: "Drop or choose file",
  folderDragDrop: "Drop or choose folder",
  menu: "Menu",
  notification: "Notification",
  numFilesSelected: (num, dir) => {
    if (num === 0) return `No ${dir ? "folder" : "files"} chosen`;
    return `${num} files`;
  },
  openMenu: "Open menu",
  rangeMax: "Maximum",
  rangeMin: "Minimum",
  sideNav: "Side navigation",
  sideNavHide: "Hide navigation",
  sideNavShow: "Show navigation",
  success: "Success",
  warning: "Warning"
};
registerTranslation(translation);
var en_default = translation;
export { en_default };
